<div class="diagnostics-summary-wrapper">

  <div class="main-layout">

    <div class="left-column">

      <div class="header-wrapper">
        <h3 class="section-title">
          Machine Diagnostics Analysis was performed at:
          <span class="value" *ngIf="!loadingDiagnoseSummary">
            {{ summary?.vibrationfaults?.updated_at || 'NOT AVAILABLE' }}
          </span>
          <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 180px; height: 20px;"></span>
        </h3>

        <div class="controls-container">
          <mat-form-field appearance="outline" class="fft-dropdown">
            <mat-label>FFT List</mat-label>
            <mat-select [(ngModel)]="FFTId" (selectionChange)="onHistoryChange($event)" [disabled]="loadingFFTList">
              <mat-option *ngIf="loadingFFTList" disabled>Loading history...</mat-option>
              <mat-option *ngFor="let item of fftList" [value]="item.value">
                {{ item.label }} {{ item.fft_time }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-raised-button color="primary" class="sa-button" (click)="onDemandSA()"
            [disabled]="loadingOnDemandSA">
            <div class="loading-wrapper">
              <mat-spinner *ngIf="loadingOnDemandSA" [diameter]="20" mode="indeterminate" color="accent"></mat-spinner>

              <span>SA On Demand</span>
            </div>
          </button>
        </div>
      </div>



      <div class="diagnostics-blocks">

        <div class="section-block">
          <h4 class="sub-title">Mechanical Health Diagnostics:</h4>
          <p class="item">
            The Predominant Condition is:
            <span *ngIf="!loadingDiagnoseSummary" class="tag"
              [ngClass]="getTagClass(summary?.vibrationfaults?.mechanicalFaults?.predominantError, 1)">
              {{ summary?.vibrationfaults?.mechanicalFaults?.predominantError || 'None' }}
            </span>
            <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 120px; height: 24px;"></span>
          </p>
          <p class="item">
            Other evolving conditions to observe are:
            <span *ngIf="!loadingDiagnoseSummary" class="tag"
              [ngClass]="getTagClass(summary?.vibrationfaults?.mechanicalFaults?.observeableError, 2)">
              {{ summary?.vibrationfaults?.mechanicalFaults?.observeableError || 'None' }}
            </span>
            <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 80px; height: 24px;"></span>
          </p>
        </div>

        <div class="section-block">
          <h4 class="sub-title">Electrical Health Diagnostics:</h4>
          <p class="item">
            The Predominant Condition is:
            <span *ngIf="!loadingDiagnoseSummary" class="tag"
              [ngClass]="getTagClass(summary?.vibrationfaults?.electricalFaults?.predominantError, 1)">
              {{ summary?.vibrationfaults?.electricalFaults?.predominantError || 'None' }}
            </span>
            <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 120px; height: 24px;"></span>
          </p>
          <p class="item">
            Other evolving conditions to observe are:
            <span *ngIf="!loadingDiagnoseSummary" class="tag"
              [ngClass]="getTagClass(summary?.vibrationfaults?.electricalFaults?.observeableError, 2)">
              {{ summary?.vibrationfaults?.electricalFaults?.observeableError || 'None' }}
            </span>
            <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 80px; height: 24px;"></span>
          </p>
        </div>

        <div class="section-block">
          <h4 class="sub-title">Ball Bearing Health Diagnostics:</h4>
          <p class="item">
            The Predominant Condition is:
            <span *ngIf="!loadingDiagnoseSummary" class="tag"
              [ngClass]="getTagClass(summary?.vibrationfaults?.bearingFaults?.predominantError, 1)">
              {{ summary?.vibrationfaults?.bearingFaults?.predominantError || 'None' }}
            </span>
            <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 120px; height: 24px;"></span>
          </p>
          <p class="item">
            Other evolving conditions to observe are:
            <span *ngIf="!loadingDiagnoseSummary" class="tag"
              [ngClass]="getTagClass(summary?.vibrationfaults?.bearingFaults?.observeableError, 2)">
              {{ summary?.vibrationfaults?.bearingFaults?.observeableError || 'None' }}
            </span>
            <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 80px; height: 24px;"></span>
          </p>
        </div>
      </div>

      <hr class="divider">

      <h3 class="section-title">
        Early Stage Ball Bearing Diagnostics Analysis was performed at:
        <span class="value" *ngIf="!loadingDiagnoseSummary">
          {{ summary?.earlyStageBallBearing?.updated_at || 'NOT APPLICABLE' }}
        </span>
        <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 160px; height: 20px;"></span>
      </h3>

      <hr class="divider">



    </div>

    <div class="right-column">
      <div class="fault-table-wrapper">
        <div class="table-header">
          Fault Classification Summary
        </div>

        <div class="table-scroll-area">
          <table class="fault-table">
            <thead>
              <tr>
                <th class="text-center">Fault Group</th>
                <th class="text-center">Description</th>
                <th class="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loadingDiagnoseSummary">
                <td colspan="3" class="text-center py-4">Analyzing...</td>
              </tr>
              <tr *ngIf="!loadingDiagnoseSummary && finalFaults.length === 0">
                <td colspan="3" class="text-center py-4 text-muted">No faults detected.</td>
              </tr>
              <tr *ngFor="let fault of finalFaults">
                <td>{{ fault.group }}</td>
                <td>{{ fault.error }}</td>
                <td class="text-center">
                  <span class="status-dot"
                    [style.background-color]="fault.color === 'red' ? colorUnacceptable : (fault.color === 'yellow' ? colorUnsatisfactory : colorHealthy)">
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
  <hr>

  <div class="section-grid">
    <div>
      <h3 class="section-title">
        Electrical Signature Analysis for Electric Motors was performed at:
        <span class="value" *ngIf="!loadingDiagnoseSummary">
          {{ summary?.esaFaults?.updated_at || 'NOT APPLICABLE' }}
        </span>
        <span *ngIf="loadingDiagnoseSummary" class="skeleton" style="width: 160px; height: 20px;"></span>
      </h3>
    </div>
    <div class="right-box">
      <span class="esa-text">ESA not Subscribed</span>
      <button class="esa-btn">Select an Option</button>
    </div>
  </div>

</div>